/**
 * @param {{
 *   ProductEditService: ReturnType<import('../../services/ProductEditService').default>,
 * }} param0
 */
export default function productEditUseCase({ ProductEditService }) {
  const editProduct = (productIdOrSlug, input) =>
    ProductEditService.editProduct(productIdOrSlug, input);

  const editProductDetail = (productIdOrSlug, productDetailId, input) =>
    ProductEditService.editProductDetail(productIdOrSlug, productDetailId, input);

  const updateProductDetailImageOrdering = (productIdOrSlug, productDetailId, input) =>
    ProductEditService.updateProductDetailImageOrdering(productIdOrSlug, productDetailId, input);

  return {
    editProduct: editProduct,
    editProductDetail: editProductDetail,
    updateProductDetailImageOrdering: updateProductDetailImageOrdering,
  };
}
